/** Fast value copying */
export default function copy(value) {
  if (value == null) {
    return value;
  }
  const type = typeof value;
  if (type === 'string' || type === 'number' || type === 'boolean') {
    return value;
  }
  if (value.constructor === Array) {
    return copyArray(value);
  }
  if (type === 'object') {
    return copyObject(value);
  }
  return structuredClone(value);
}

/** Fast array copying */
function copyArray(value) {
  const length = value.length;
  if (length === 0) {
    return [];
  }
  const result = new Array(length);
  for (let i = 0; i < length; i++) {
    result[i] = copy(value[i]);
  }
  return result;
}

/** Fast object copying */
function copyObject(value) {
  const result = {};
  for (const key in value) {
    if (Object.hasOwn(value, key)) {
      result[key] = copy(value[key]);
    }
  }
  return result;
}
